/* eslint-disable @next/next/no-img-element */
import type { FC, ReactNode } from 'react'
import type { BlogPost } from '@/data/blog'

import Link from 'next/link'

import { routes } from '@/lib/routes'
import { formatDate } from '@/lib/format'

type BlogCardProps = {
    post: BlogPost
    featured?: boolean
}

export const BlogCard: FC<BlogCardProps> = ({ post, featured = false }): ReactNode => {
    if (featured) {
        return (
            <Link href={routes.blogPost(post.slug)} className='featured-blog-post-holder w-inline-block'>
                <div className='thumbnail-image-holder'>
                    <img src={post.thumbnail} loading='lazy' alt={post.name} className='thumbnail-image' />
                </div>
                <div className='featured-blog-description-holder'>
                    <div className='blog-description-holder-copy'>
                        <div className='blog-item-text-header'>
                            <div className='category-holder'>
                                <div className='category-text'>{post.categoryName}</div>
                            </div>
                            <div className='blog-item-date-circle' />
                            <div className='blog-item-date'>
                                <div className='blog-item-publish-date'>{formatDate(post.publishDate)}</div>
                            </div>
                        </div>
                        <div className='blog-item-title'>{post.name}</div>
                        <div className='fade-in-on-scroll'>
                            <p className='grey-text'>{post.summary}</p>
                        </div>
                    </div>
                </div>
            </Link>
        )
    }

    return (
        <div role='listitem' className='blog-item w-dyn-item'>
            <Link href={routes.blogPost(post.slug)} className='blog-item-link w-inline-block'>
                <div className='small-thumbnail-image'>
                    <img src={post.thumbnail} loading='lazy' alt={post.name} className='blog-item-image' />
                </div>
                <div className='blog-description-holder-copy'>
                    <div className='blog-item-text-header'>
                        <div className='category-holder'>
                            <div className='category-text'>{post.categoryName}</div>
                        </div>
                        <div className='blog-item-date-circle' />
                        <div className='blog-item-date'>
                            <div className='blog-item-publish-date'>{formatDate(post.publishDate)}</div>
                        </div>
                    </div>
                    <div className='blog-item-title'>{post.name}</div>
                    <div className='fade-in-on-scroll'>
                        <p className='grey-text'>{post.summary}</p>
                    </div>
                </div>
            </Link>
        </div>
    )
}
